import React from "react";
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";

interface ActionButtonsProps {
  onAddInterview?: () => void;
  onDeleteInterview?: () => void;
  canDelete?: boolean;
  isSaving?: boolean;
  isDeleting?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onAddInterview,
  onDeleteInterview,
  canDelete = false,
  isSaving = false,
  isDeleting = false,
}) => {
  return (
    <div className="flex items-center gap-2">
      {onAddInterview && (
        <Button
          variant="outline"
          size="sm"
          onClick={onAddInterview}
          disabled={isSaving}
          className="h-9 gap-1 bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:border-gray-400 dark:hover:border-gray-500 hover:text-gray-900 dark:hover:text-gray-100 font-normal transition-all disabled:opacity-50"
        >
          <Plus className="h-4 w-4" />
          <span>Add Interview</span>
        </Button>
      )}

      {onDeleteInterview && canDelete && (
        <Button
          variant="destructive"
          size="sm"
          onClick={onDeleteInterview}
          disabled={isSaving || isDeleting}
          className="h-9 gap-1 shadow-sm transition-all disabled:opacity-50"
        >
          {isDeleting ? (
            <>
              <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
              <span>Deleting...</span>
            </>
          ) : (
            <>
              <Trash2 className="h-4 w-4" />
              <span>Delete</span>
            </>
          )}
        </Button>
      )}

      {isSaving && !isDeleting && (
        <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
          <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-blue-600 rounded-full"></div>
          <span>Saving...</span>
        </div>
      )}
    </div>
  );
};

export default ActionButtons;
